const SELECT_CLASS = "js-dd-selector";
const OPEN_CLASSS = "select-open";

function init() {
	const list = ["select", SELECT_CLASS];

	list.forEach((selector) => {
		$(selector).addClass(SELECT_CLASS);
	});

	const $select = $(`.${SELECT_CLASS}`);

	$select.click(function () {
		$(this).toggleClass(OPEN_CLASSS);
	});

	$select.focusout(function () {
		$(this).removeClass(OPEN_CLASSS);
	});
}

export { init };
